import React, {
  useContext,
  useEffect,
  useState,
} from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import CustomInput from '../../generic/CustomInput/CustomInput';
import CustomBtn from '../../generic/CustomBtn/CustomBtn';
import RegisterNewFieldAgent from '../../components/PopUp/RegisterNewFieldAgent';
import EditFieldAgentPopUp from '../../components/PopUp/EditFieldAgentPopUp';
import RemoveFieldAgentPopUp from '../../components/PopUp/RemoveFieldAgentPopUp';
import { requestApi } from '../../utils/api-request';
import exclamationMarkAlt from '../../assets/image/map/exclamation-mark-alt.svg';
import Loader from '../../components/Loader';
import TableHeaderElement from '../../generic/TableHeaderElement';
import { sortData } from '../../utils/sort';
import { appStore } from '../../state/app';

const MyFieldAgentsList = ({ item }) => {
  const [resendIcon, setResendIcon] = useState(false);
  const [editFieldAgentPopUp, setEditFieldAgentPopUp] = useState(false);
  const [removeFieldAgentPopUp, setRemoveFieldAgentPopUp] = useState(false);
  const [fieldAgensInfo, setFieldAgentInfo] = useState({});
  const translate = useIntl();

  const resendInvite = async (id) => {
    await requestApi('PUT', '/api/dashboard/field-agent/invite', { field_agent_id: id });
  };

  return (
    <>
      <div className="list-body">
        <div className="list-body-item overflow-scroll">{item.name}</div>
        <div className="list-body-item overflow-scroll">{item.email}</div>
        <div className="list-body-item overflow-scroll">{item?.projects ? item.projects.join(', ') : '---'}</div>
        <div className="list-body-item overflow-scroll cta-btn-block">
          <CustomBtn
            label={translate.formatMessage({ id: 'fieldAgents.editFA' })}
            customClass="cta-btn-block-item"
            iconClass="icon-pencil-alt"
            handleClick={() => {
              setFieldAgentInfo({
                field_agent_id: item.id,
                field_agent_name: item.name,
                field_agent_email: item.email,
              });
              setEditFieldAgentPopUp(!editFieldAgentPopUp);
            }}
          />
          <CustomBtn
            label={translate.formatMessage({ id: 'fieldAgents.resendInvite' })}
            customClass="cta-btn-block-item"
            iconClass={!resendIcon ? 'icon-reload' : 'icon-check-circle'}
            disabled={resendIcon}
            handleClick={() => {
              resendInvite(item.id);
              setResendIcon(!resendIcon);
            }}

          />
          <CustomBtn
            customClass="cta-btn-block-item"
            handleClick={() => {
              setFieldAgentInfo({
                field_agent_id: item.id,
                field_agent_name: item.name,
                field_agent_email: item.email,
              });
              setRemoveFieldAgentPopUp(!removeFieldAgentPopUp);
            }}
            iconClass="icon-trash"
          />
        </div>
      </div>
      {editFieldAgentPopUp ? (
        <EditFieldAgentPopUp
          showPopUp={editFieldAgentPopUp}
          setShowPopUp={setEditFieldAgentPopUp}
          fieldAgensInfo={fieldAgensInfo}
        />
      ) : null}
      {removeFieldAgentPopUp ? (
        <RemoveFieldAgentPopUp
          showPopUp={removeFieldAgentPopUp}
          setShowPopUp={setRemoveFieldAgentPopUp}
          fieldAgensInfo={fieldAgensInfo}
        />
      ) : null}
    </>
  );
};

const MyFieldAgents = () => {
  const [registerAgentPopUp, setRegisterAgentPopUp] = useState(false);
  const [loadingData, setLoading] = useState(true);
  const [myFieldAgentSearch, setMyFieldAgentSearch] = useState('');
  const [myFieldAgentList, setMyFieldAgentList] = useState([]);
  const [noSearchData, setNoSearchData] = useState();
  const [queryResultFieldAgent, setQueryResultFieldAgent] = useState([]);
  const { state } = useContext(appStore);
  const { app } = state;
  const translate = useIntl();

  useEffect(async () => {
    const result = await requestApi('GET', '/api/dashboard/field-agent/list');
    setMyFieldAgentList(result);
    setLoading(false);
  }, [app.allFa]);

  const concurrenceProjects = (projects, valueSearch) => {
    for (const project of (projects || [])) {
      if (project.toLowerCase().includes(valueSearch)) {
        return true;
      }
    }
    return false;
  };

  useEffect(() => {
    const filteredObjFieldAgents = myFieldAgentList?.filter((obj) => {
      const valueSearch = myFieldAgentSearch.toLowerCase().trim();
      const { name = '', email = '', projects } = obj;
      return name.toLowerCase().includes(valueSearch) || email.toLowerCase().includes(valueSearch) || concurrenceProjects(projects, valueSearch);
    });
    setQueryResultFieldAgent(filteredObjFieldAgents);
    setNoSearchData(filteredObjFieldAgents);
  }, [myFieldAgentList, myFieldAgentSearch]);

  if (loadingData) {
    return (
      <div className="my-field-agent__loader">
        <Loader />
      </div>
    );
  }

  const projectDataSort = (sortName, sortAscDesc) => {
    const resSort = sortData(myFieldAgentList, sortName, sortAscDesc);
    setMyFieldAgentList([...resSort]);
  };

  return (
    <div className="my-field-agent">
      <div className="my-field-agent__header">
        <h2 className="my-field-agent__header-title">{translate.formatMessage({ id: 'fieldAgents.myFieldAgents' })}</h2>
        <div className="my-field-agent__cta-block">
          {!!myFieldAgentList?.length && (
            <div className="my-field-agent__searchInput">
              <CustomInput
                type="text"
                placeholder={translate.formatMessage({ id: 'fieldAgents.searchFA' })}
                customClass="input-search"
                iconClass="icon-search"
                change={(event) => setMyFieldAgentSearch(event.target.value)}
              />
            </div>
          )}
          <CustomBtn
            label={translate.formatMessage({ id: 'fieldAgents.registerNewFA' })}
            handleClick={() => setRegisterAgentPopUp(!registerAgentPopUp)}
            customClass="my-field-agent__btn-assign"
          />
        </div>
      </div>
      {myFieldAgentList?.length ? (
        <div className="my-field-agent__list-wrapper">
          {noSearchData?.length === 0 ? (
            <div className="noSearchData">
              {translate.formatMessage({ id: 'fieldAgents.noResultsFound' })}
            </div>
          ) : (
            <>
              <div className="list-header">
                <TableHeaderElement
                  params={{
                    projectDataSort,
                    sortName: 'name',
                    value: translate.formatMessage({ id: 'fieldAgents.name' }),
                  }}
                />
                <TableHeaderElement
                  params={{
                    projectDataSort,
                    sortName: 'email',
                    value: translate.formatMessage({ id: 'fieldAgents.email' }),
                  }}
                />
                <TableHeaderElement
                  params={{
                    value: translate.formatMessage({ id: 'fieldAgents.project' }),
                  }}
                />
                <TableHeaderElement
                  params={{
                    value: translate.formatMessage({ id: 'fieldAgents.action' }),
                  }}
                />
              </div>
              {queryResultFieldAgent?.map((item) => (
                <React.Fragment key={item.id}>
                  <MyFieldAgentsList item={item} />
                </React.Fragment>
              ))}
            </>
          )}
        </div>
      ) : (
        <div className="my-field-agent__empty">
          <div className="my-field-agent__exclamation">
            <img src={exclamationMarkAlt} alt="Exclamation" />
          </div>
          <FormattedMessage
            id="fieldAgents.emptyList2"
            values={{
              div: (...chunks) => <div className="empty-text">{chunks}</div>,
              bold: (chunks) => <b>{chunks}</b>,
              br: <br />,
            }}
          />
        </div>
      )}
      {registerAgentPopUp ? (
        <RegisterNewFieldAgent
          showPopUp={registerAgentPopUp}
          setShowPopUp={setRegisterAgentPopUp}
        />
      ) : null}
    </div>
  );
};

export default MyFieldAgents;
